module.exports = __webpack_public_path__ + "static/media/thumbs-down.651c55bb.png";